// src/pages/TrafficAnalyzer.js
import React from 'react';
import Layout from '../components/Layout';
import ComingSoon from '../components/ComingSoon';

function TrafficAnalyzer() {
    return (
        <Layout>
            <ComingSoon>
            <div className="p-8">
            <h1 className="text-4xl font-bold text-white mb-8">Traffic Analyzer</h1>
            <div className="mb-16 gap-16">
                   <h1 className="text-4xl font-bold text-gray-400 mb-8">Coming Soon</h1>
                </div>
            </div>
            </ComingSoon>
        </Layout>
    );
}

export default TrafficAnalyzer;